export default "__VITE_ASSET__BOcpYBF7__"